import React from 'react';
import Fade from 'react-reveal';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Footer = ({ data }) => {
  if (!data) return null;

  const { copyright, designed, privacyPolicy, social } = data;

  const networks = social.map((network) => {
    const { name, url, className } = network;
    return (
      <li key={name}>
        <a href={url} target="_blank" rel="noreferrer">
          <i className={className} />
        </a>
      </li>
    );
  });

  return (
    <footer>
      <div className="row">
        <Fade bottom>
          <div className="twelve columns">
            <ul className="social-links">{networks}</ul>
            <ul className="copyright">
              <li>{copyright}</li>
              <li>{designed}</li>
              <li>
                <Link to="/privacy-policy">{privacyPolicy}</Link>
              </li>
            </ul>
          </div>
        </Fade>

        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="src/components#home">
            <i className="icon-up-open" />
          </a>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  data: PropTypes.shape({
    social: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        className: PropTypes.string,
      }),
    ),
    copyright: PropTypes.string,
    designed: PropTypes.string,
    privacyPolicy: PropTypes.string,
  }).isRequired,
};

export default Footer;
